export const BASE_PRICE_REQUEST = 'BASE_PRICE_REQUEST';
export const BASE_PRICE_SUCCESS = 'BASE_PRICE_SUCCESS';
export const BASE_PRICE_ERROR = 'BASE_PRICE_ERROR';
export const FACTORS_REQUEST = 'FACTORS_REQUEST';
export const FACTORS_SUCCESS = 'FACTORS_SUCCESS';
export const FACTORS_ERROR = 'FACTORS_ERROR';
export const CLEAR_PRODUCT_STORE = 'CLEAR_PRODUCT_STORE';
